module.exports = __webpack_public_path__ + "static/media/quality_assurance.56f8b483.svg";